import { render, staticRenderFns } from "./PopupLayer.vue?vue&type=template&id=1f106cb8&scoped=true&"
import script from "./PopupLayer.vue?vue&type=script&lang=js&"
export * from "./PopupLayer.vue?vue&type=script&lang=js&"
import style0 from "./PopupLayer.vue?vue&type=style&index=0&id=1f106cb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f106cb8",
  null
  
)

export default component.exports